import React from 'react';
import { NextSeo } from 'next-seo';
import s from './style.module.scss';
import RootLayout from '../../component/Layout';
import { time_format } from '../../utils';
import useScreenWidthBelowThreshold from '../../hooks/useScreenWidthBelowThreshold';
import Link from 'next/link';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';

const marked = require('marked');

const DIVIDER_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik9GV05WMlVUWlQ0R1pBNzNSNklONjNYQVhWSU5XUSIsInciOjI4ODAsImgiOjIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjowLCJhYiI6MH0.png';
const LOGO_PATH =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6IkFETTRZQkFRNTQySDNJTzVJNTVNQkpHQVBRN0xSRSIsInciOjI0MCwiaCI6NzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxNzM4MzkwMTQ2MjQzNjQ4ODIsImFiIjowfQ.png';

export default function NewsDetails({ title, keyword, description, content, avatar, author, updated_time, tags }) {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);

  return (
    <>
      <NextSeo
        title={title} // 使用从 API 获取的 title
        description={description} // 使用从 API 获取的 description
        additionalMetaTags={[
          {
            name: 'keywords',
            content: keyword, // 使用从 API 获取的 keyword
          },
        ]}
      />
      <RootLayout className={s.newsBody}>
        {!isScreenWidthBelow700px && (
          <Link href="/">
            <H5Image type="origin" src={LOGO_PATH} className={s.logo} />
          </Link>
        )}
        <div className={s.contentWrapper}>
          <div className={s.title}>{title}</div>
          <div className={s.autherContent}>
            <div className={s.avatar}>
              <H5Image src={avatar} className={s.avatarImg} />
            </div>
            <div>
              <div className={s.auther}>{author}</div>
              <div className={s.updateTime}>{time_format(updated_time, 'MMM DD, YYYY')}</div>
            </div>
          </div>
          <div className={s.tagWrapper}>
            {tags?.slice(0, 3)?.map((tag) => (
              <div key={tag} className={s.tag}>
                {tag}
              </div>
            ))}
          </div>
          <H5Image type="origin" src={DIVIDER_PATH} className={s.divider} />
          <div className={s.newsContainer}>
            <div className={s.newsDetails}>
              <div className="news-detail-md news-detail-md-black-bg" dangerouslySetInnerHTML={{ __html: marked.parse(content || '') }} />
            </div>
          </div>
        </div>
      </RootLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { id } = context.query;
  const response = await fetch(`${process.env.API_URL}/api/content`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
  const props = response.json();
  return { props };
}
